<template>
  <div class="completion-message-step">
    <div>
      <Typography variant="h-5">
        Do you want to add an introduction card to this survey?
      </Typography>
      <Typography variant="body-2" class="pt-1"
        >With no introduction card, users open the survey and start with the first
        question.</Typography
      >
    </div>
    <v-radio-group :value="enabled" @change="$emit('update:enabled', $event)" hide-details>
      <v-radio label="No Introduction" :value="false" color="brandPrimary" />
      <v-radio label="Add Introduction" :value="true" color="brandPrimary" />
    </v-radio-group>
    <LearningCardEditor
      v-if="enabled"
      ref="editor"
      :display-name="displayName"
      :content="content"
      :client-id="clientId"
      title-label="Introduction Title*"
      placeholder="Introduction message content"
      @update:displayName="$emit('update:displayName', $event)"
      @update:content="$emit('update:content', $event)"
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import LearningCardEditor from "@/components/module-builder/components/LearningCardEditor.vue";

export default {
  name: "IntroductionMessageStep",
  components: {
    Typography,
    LearningCardEditor,
  },
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    displayName: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    clientId: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ["update:enabled", "update:displayName", "update:content"],
  methods: {
    validate() {
      if (!this.enabled) return true;
      return this.$refs.editor?.validate() ?? true;
    },
  },
};
</script>

<style scoped>
.completion-message-step {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
